export default function () {
    return {
        customers: [],
        customersPerPage: 50,
    };
}
